import richTextify from "@utilities/richtext";
import clsx from "clsx";
import styles from "./RichTextDisplay.module.scss";

const RichTextDisplay = ({
  richText,
  tinyMceRichText,
  richTextStyles = false,
  addBorder = false,
  capitaliseFirstLetter = false,
  hideFromScreenReaders = false,
}) => {
  let rtContent = tinyMceRichText?.richText;
  const rex = /<a\s+(?:[^>]*?\s+)?href=(["'])(..\/\/*?)/gm;
  const matchArr = rtContent?.match(rex);
  if (matchArr) {
    for (let i = 0; i < matchArr.length; i++) {
      const newLink = matchArr[i].replace('href="../', 'href="/');
      rtContent = rtContent.replace(matchArr[i], newLink);
    }
  }
  return (
    <div
      aria-hidden={hideFromScreenReaders}
      className={clsx(
        richTextStyles && styles["rich-text"],
        capitaliseFirstLetter && styles["drop-caps"],
        addBorder && styles.border
      )}
    >
      {richText && richText?.content?.length ? (
        richTextify(richText)
      ) : tinyMceRichText?.richText ? (
        <div dangerouslySetInnerHTML={{ __html: rtContent }} />
      ) : null}
    </div>
  );
};

export default RichTextDisplay;
